import { render, staticRenderFns } from "./AgentCommissionsTable.vue?vue&type=template&id=08f50cd6&"
import script from "./AgentCommissionsTable.vue?vue&type=script&lang=js&"
export * from "./AgentCommissionsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports